export const APP_LOCALSTORAGE_JWT = 'bp_jwt';
export const APP_LOCALSTORAGE_USER = 'bp_user';
